"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CALENDAR_REMINDER_SYSTEM", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CALENDAR_REMINDER_SYSTEM;
  }
});
Object.defineProperty(exports, "CAMPAIGN_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CAMPAIGN_MANAGEMENT;
  }
});
Object.defineProperty(exports, "CONTACT_ACCOUNT_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CONTACT_ACCOUNT_MANAGEMENT;
  }
});
Object.defineProperty(exports, "DASHBOARDS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DASHBOARDS;
  }
});
Object.defineProperty(exports, "DATA_IMPORT_EXPORT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DATA_IMPORT_EXPORT;
  }
});
Object.defineProperty(exports, "EMAIL_MARKETING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.EMAIL_MARKETING;
  }
});
Object.defineProperty(exports, "EMAIL_TRACKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.EMAIL_TRACKING;
  }
});
Object.defineProperty(exports, "FORECASTING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.FORECASTING;
  }
});
Object.defineProperty(exports, "INTEGRATION_APIS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.INTEGRATION_APIS;
  }
});
Object.defineProperty(exports, "INTERNAL_CHAT_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.INTERNAL_CHAT_INTEGRATION;
  }
});
Object.defineProperty(exports, "LEAD_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.LEAD_MANAGEMENT;
  }
});
Object.defineProperty(exports, "LEAD_SCORING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.LEAD_SCORING;
  }
});
Object.defineProperty(exports, "MARKETING_AUTOMATION_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MARKETING_AUTOMATION_INTEGRATION;
  }
});
Object.defineProperty(exports, "MOBILE_APP", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MOBILE_APP;
  }
});
Object.defineProperty(exports, "OPPORTUNITY_PIPELINE_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.OPPORTUNITY_PIPELINE_MANAGEMENT;
  }
});
Object.defineProperty(exports, "SOCIAL_MEDIA_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SOCIAL_MEDIA_MANAGEMENT;
  }
});
Object.defineProperty(exports, "SOCIAL_NETWORK_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SOCIAL_NETWORK_INTEGRATION;
  }
});
Object.defineProperty(exports, "TASK_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.TASK_MANAGEMENT;
  }
});
Object.defineProperty(exports, "TERRITORY_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.TERRITORY_MANAGEMENT;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/CRM.js
// module id = 565
// module chunks = 209 210 211 212 213